export enum SpinnerType {
  Default = 'default',
  Progress = 'progress',
}
